module.exports = __webpack_public_path__ + "img/necesitas_four.d8aa62db.png";